module.exports = "/_next/static/videos/game-feedback-5d09a34b2f23922128b63c72628f00df.mp4";